import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const FLOW: { label: string; to: string; group: string }[] = [
  { label: 'Landing',                to: '/',                              group: 'Public'    },
  { label: 'Inscription',            to: '/inscription',                   group: 'Auth'      },
  { label: 'Connexion',              to: '/connexion',                     group: 'Auth'      },
  { label: 'Vérification email',     to: '/verifier-email',                group: 'Auth'      },
  { label: 'Infos personnelles',     to: '/kyc/informations-personnelles', group: 'KYC'       },
  { label: "Pièce d'identité",       to: '/kyc/identite',                  group: 'KYC'       },
  { label: 'Selfie',                 to: '/kyc/selfie',                    group: 'KYC'       },
  { label: 'Justificatif domicile',  to: '/kyc/justificatif-domicile',     group: 'KYC'       },
  { label: 'Source des fonds',       to: '/kyc/source-des-fonds',          group: 'KYC'       },
  { label: 'Revue & validation',     to: '/kyc/revue',                     group: 'KYC'       },
  { label: 'Choix du wallet',        to: '/wallet/creation',               group: 'Wallet'    },
  { label: 'Wallet créé',            to: '/wallet/cree',                   group: 'Wallet'    },
  { label: 'Marketplace',            to: '/actifs',                        group: 'Actifs'    },
  { label: 'Investissement',         to: '/investissement',                group: 'Actifs'    },
  { label: 'Publier un actif',       to: '/admin/publier-actif',           group: 'Admin'     },
  { label: 'Tableau de bord',        to: '/tableau-de-bord',               group: 'Dashboard' },
  { label: 'Portail dette P4.3',     to: '/app',                           group: 'Dashboard' },
  { label: 'Portefeuille',           to: '/portefeuille',                  group: 'Dashboard' },
  { label: 'Rendement',              to: '/rendement',                     group: 'Dashboard' },
];

const GROUPS = Array.from(new Set(FLOW.map((f) => f.group)));

export function DevNav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <>
      {/* Panel — uniquement quand ouvert, rendu séparément du bouton */}
      {open && (
        <div className="fixed bottom-14 right-4 z-[9998] w-52 rounded-xl border border-ink-200 bg-white shadow-card-lg overflow-hidden">
          <div className="border-b border-ink-100 px-3 py-2">
            <p className="text-[9px] font-bold uppercase tracking-widest text-ink-300">
              Navigation — DEV ONLY
            </p>
          </div>
          <div className="max-h-[70vh] overflow-y-auto py-1">
            {GROUPS.map((group) => (
              <div key={group}>
                <p className="px-3 pt-2 pb-0.5 text-[9px] font-extrabold uppercase tracking-widest text-ink-300">
                  {group}
                </p>
                {FLOW.filter((f) => f.group === group).map(({ label, to }) => (
                  <Link
                    key={to}
                    to={to}
                    className={`block px-3 py-1.5 text-[12px] no-underline transition-colors ${
                      pathname === to
                        ? 'bg-primary-50 font-semibold text-primary-700'
                        : 'text-ink-700 hover:bg-ink-50'
                    }`}
                  >
                    {pathname === to && (
                      <span className="mr-1.5 inline-block h-1.5 w-1.5 rounded-full bg-primary-500 align-middle" />
                    )}
                    {label}
                  </Link>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Bouton toggle — élément fixe indépendant, ne bloque rien */}
      <button
        onClick={() => setOpen((v) => !v)}
        className="fixed bottom-4 right-4 z-[9999] flex items-center gap-1.5 rounded-lg bg-ink-950/85 px-3 py-2 text-[11px] font-bold uppercase tracking-widest text-white/60 shadow-card-lg backdrop-blur transition hover:text-white"
      >
        <span className={`h-1.5 w-1.5 rounded-full transition-colors ${open ? 'bg-amber-400' : 'bg-primary-400'}`} />
        DEV
      </button>
    </>
  );
}
